module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0bd32feab34717d83b8edcf777c81a63.png";